<template>
  <p class="call font-roboto flex items-center justify-center gap-4">Have a question? Call
    <img src="@/images/quote-builder/phone.svg" alt="Give as a call">
    <a :href="`tel:${organization.phone}`">
      {{ formatPhoneNumber(organization.phone) }}
    </a>
  </p>
</template>

<script>
import { formatPhoneNumber } from '../../../../shared/utils'
import Step from '../../flow/steps/mixin'

export default {
  mixins: [ Step ],
  methods: {
    formatPhoneNumber
  }
}
</script>

<style scoped lang="scss">
.call {
    width: 100%;
    height: 48px;
    background-color: #FFF;
    color: #334155;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    a {
      color: #1F44F1;
      font-size: 18px;
      font-weight: 400;
      line-height: 27px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
  }
  
</style>